export default __webpack_public_path__ + "static/media/noytrall_logo_white.3d6446f7.svg";